import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

const userApi = {
  // list (params) {
  //   return axios.get(
  //     `api/shows/`,
  //     {params: params})
  // },
  // detail (showSlug, params) {
  //   // let params = querystring..stringify(params)
  //   return axios.get(`api/shows/${showSlug}/`, {params: params})
  // }
  wechatProfile (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/users/wechatprofile/`, {params: params})
  }
}

export default userApi
